export default {

    props: {

        // The skeleton type to show when the items are loading
        skeleton: {
            type: String,
            default: 'image'
        },

        // The amount of skeletons to show when the items are loading
        skeletonCols: {
            type: [Number, Boolean, String],
            default: 12
        },

        // The amount of skeletons to show when the items are loading on small devices
        skeletonColsSm: {
            type: [Number, Boolean, String],
            default: false
        },

        // The amount of skeletons to show when the items are loading on medium devices
        skeletonColsMd: {
            type: [Number, Boolean, String],
            default: false
        },

        // The amount of skeletons to show when the items are loading on large devices
        skeletonColsLg: {
            type: [Number, Boolean, String],
            default: false
        },

        // The amount of skeletons to show when the items are loading on extra large devices
        skeletonColsXl: {
            type: [Number, Boolean, String],
            default: false
        },
    }
}

